// 审核状态
export const AUDIT_STATUS_OPTIONS = [
  {
    label: '待审核',
    value: 0,
  },
  {
    label: '通过',
    value: 2,
  },
  {
    label: '驳回',
    value: 3,
  },
];

//  审核姓名搜索下拉框
const auditiongSelectTypes = ['客户名称', '客户编号', '业务员', '创建人'];

export const AUDIT_SEARCH_SELECT_OPTIONS = auditiongSelectTypes.map((label, index) => ({
  label,
  value: index + 1,
}));
